import { getEventEmitter } from '@process-advisor/process-miner/processMiner/processMiner';
import { Event } from '@process-advisor/process-miner/api/events';

export type StepCostModalProps = {
    data: {
        description: string,
        costID: number,
        fromActivity: string,
        fromActivityStr: string,
        toActivity: string,
        toActivityStr: string,
        cost: number,
        costType: string,
        variantType: string,
        issueType: string,
        mode: string,
        attribute: string,
        reductionType: string, 
        reductionPercentage: number,
        reductionCost: number,
        reductionDuration: number,
        reductionValue: string
    }
}

export const openStepCostModal = ({ data }: StepCostModalProps) => {
    getEventEmitter().emit(Event.openStepCostModal, { data });
};
